export const separator = `
<svg width="1" height="561" viewBox="0 0 1 561" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 560C0 560.276 0.223858 560.5 0.5 560.5C0.776142 560.5 1 560.276 1 560H0.5H0ZM0.5 0L0 0L0 560H0.5H1L1 0L0.5 0Z" fill="url(#paint0_linear_3301_5)"/>
<defs>
<linearGradient id="paint0_linear_3301_5" x1="-0.5" y1="0" x2="-0.5" y2="560" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.5" stop-color="#0C3C5E"/>
<stop offset="1" stop-color="white"/>
</linearGradient>
</defs>
</svg>
`
